import axios from "axios";
export const checkServerAvailable = async () => axios
    .get(`/healthCheck.txt?timestamp=${new Date().getTime()}`)
    .then(() => true)
    .catch((error) => {
    if (error.response) {
        return true;
    }
    else if (error.request) {
        if (error.message === "Network Error") {
            return false;
        }
        return true;
    }
});
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
